import React, { useState, useEffect  } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const Completed: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { name, mobile, whatsapp, email } = location.state || {};
  const [showAlert, setShowAlert] = useState(true);
  /*
  const handleClick = () => {
    navigate('/otp');
  };
*/
  return (
    <div className="div-container" >
      <label>
        <div style={styles.alertBox as React.CSSProperties}>
          <h2>Hi! {name}, Welcome to Ariseupp7!</h2>
          <p>Our team will reach out to you shortly.</p>
          <br></br>
          <p>If you need any further assistance or have any questions, feel free to contact us at support@ariseupp7.org</p>
        </div>
      </label>
    </div>
  );
};

const styles = {
  alertBox: {
    backgroundColor: '#4CAF50',// '#4CAF50', // Green background color
    color: 'white',
    padding: '20px',
    borderRadius: '5px',
    //top: '50px',
    //position: 'fixed',
    zIndex: 1000, // Ensure it shows on top of other elements
    fontSize: '16px',
    textAlign: 'center',
  }
};
export default Completed;